import * as DG from "ui/dialogs"
import { useState } from "react"

import {
  Document,
  fileIcons,
  mimeTypes,
  newDocumentEmpty,
} from "models/documents"
import { Form, Formik } from "formik"
import {
  column,
  filename,
  formWrapper,
  image,
  progressIcon,
  progressWrapper,
} from "./styles"

import Button from "ui/buttons/Button"
import { ReactComponent as CheckIcon } from "assets/check.svg"
import { DocumentType } from "components/AdminDocuments"
import LinearProgress from "@material-ui/core/LinearProgress"
import { NewDocumentFieldGroup } from "./NewDocumentFieldGroup"
import { PageType } from "api/types"
import { cx } from "@emotion/css"
import { useI18n } from "providers/I18n"

export type DocumentUploadModalProps = {
  open: boolean
  type: PageType | "invoice"
  document?: Document
  onSubmit: (document: Document) => void
  onCancel: () => void
  documentTypes?: DocumentType[]

  //
  dropStatus?: "idle" | "pending" | "success" | "rejected"
}

export function DocumentUploadModal(props: DocumentUploadModalProps) {
  const {
    open,
    type,
    document,
    onSubmit,
    onCancel,
    documentTypes,
    dropStatus,
  } = props
  const { t } = useI18n()

  const [hasCategory, setHasCategory] = useState(() => false)

  const handleSubmit = (values: Document) => {
    if (document !== undefined) {
      onSubmit({ ...document, ...values })
      setHasCategory(false)
    }
  }

  const validate = (values: Document) => {
    setHasCategory(
      ((type === "campaign" ||
        type === "agency" ||
        type === "client" ||
        type === "config" ||
        type === "clientgroups" ||
        type === "suppliergroups" ||
        type === "company" ||
        type === "supplier") &&
        values.documentType !== undefined) ||
        (type === "plan" && values.mediaType !== undefined) ||
        type === "invoice",
    )
  }

  const isValid = hasCategory

  const id = "upload-document-dialog"
  return (
    <DG.Dialog open={open} onClose={onCancel} id={id}>
      <Formik<Document>
        initialValues={newDocumentEmpty}
        onSubmit={handleSubmit}
        validate={validate}
      >
        {() => {
          return (
            <>
              <DG.DialogHeader>
                <DG.DialogTitle id={id}>
                  {t("document.upload.title")}
                </DG.DialogTitle>
                <DG.DialogClose onClose={onCancel} />
              </DG.DialogHeader>

              <DG.DialogContent paddingTop>
                <div className={progressWrapper}>
                  {document?.file?.type !== undefined &&
                  document?.file?.type !== "" ? (
                    <img
                      src={fileIcons[mimeTypes[document.file?.type]]}
                      alt={document.file?.type}
                      className={image}
                    />
                  ) : null}
                  <div className={column}>
                    <p className={cx("BodyBody-2BlackBold", filename)}>
                      {document?.file?.name}
                    </p>
                    {dropStatus === "pending" ? (
                      <LinearProgress variant="indeterminate" />
                    ) : null}
                    {dropStatus === "success" ? (
                      <>
                        <LinearProgress variant="determinate" value={100} />
                      </>
                    ) : null}
                  </div>
                  {dropStatus === "success" ? (
                    <>
                      <div className={progressIcon}>
                        <CheckIcon />
                      </div>
                    </>
                  ) : null}
                </div>
                <div className={formWrapper}>
                  <Form id="new_document">
                    <NewDocumentFieldGroup
                      disabled={dropStatus === "pending"}
                      margin="normal"
                      type={type}
                      documentTypes={documentTypes}
                    />
                  </Form>
                </div>
              </DG.DialogContent>
              <DG.DialogFooter>
                <DG.DialogActions>
                  <Button
                    variant="outlined"
                    color="primary"
                    disabled={dropStatus === "pending"}
                    onClick={onCancel}
                  >
                    {t("document.button.cancel")}
                  </Button>
                  <Button
                    disabled={dropStatus === "pending" || !isValid}
                    type="submit"
                    form="new_document"
                    color="primary"
                    variant="contained"
                  >
                    {t("document.button.submit")}
                  </Button>
                </DG.DialogActions>
              </DG.DialogFooter>
            </>
          )
        }}
      </Formik>
    </DG.Dialog>
  )
}
